import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState } from 'react';
import { Popup, Button } from 'semantic-ui-react';
import { DEFAULT_CLASS_NAME, DEFAULT_CLOSE_POPUP_TIMEOUT } from './AccordionsPopup.constants';
import useResponsive from '../../../../../../../../hooks/use-responsive/use-responsive';
import { SiteNavigationLinkPropType } from '../../../../../../../../services/proptypes';
import { listenToStyleDomChanges } from '../../../../../../../../utils/dom';
import Icon from '../../../../../../../foundation/components/Icon/Icon';
import { PopupUtils } from '../../../../../../../foundation/services/popup';
import BaseLink from '../../../Link';
import { MAX_LINKS_TO_SHOW } from '../AccordionLinks/AccordionLinks.constants';
import PopupContent from '../PopupContent';
import './AccordionsPopup.css';
var defaultProps = {
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  desktop: {
    fullScreen: true
  }
};
export default function AccordionsPopup(_ref) {
  var parentLink = _ref.parentLink,
    links = _ref.links,
    maxLinksToShow = _ref.maxLinksToShow,
    desktop = _ref.desktop;
  var desktopFullScreen = desktop.fullScreen;
  var triggerRef = useRef(null);
  var observerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var _useResponsive = useResponsive(),
    isDesktop = _useResponsive.isDesktop;
  var hoveringPopupContentRef = useRef(false);
  var timeoutId = useRef(null);
  function onParentTransformChange() {
    if (isDesktop && desktopFullScreen) {
      PopupUtils.makePopupFullWidth(document.querySelector(".".concat(DEFAULT_CLASS_NAME)));
    }
  }
  function onPopupMount() {
    var component = document.querySelector(".".concat(DEFAULT_CLASS_NAME));
    var parentElement = component.parentNode;
    observerRef.current = listenToStyleDomChanges(parentElement, onParentTransformChange);
  }
  function onPopupUnmount() {
    observerRef.current.disconnect();
  }
  function toggleShowPopup() {
    setShowPopup(function (previousShowPopup) {
      return !previousShowPopup;
    });
  }
  function displayPopup() {
    setShowPopup(true);
  }
  function hidePopup() {
    setShowPopup(false);
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
  }
  function onMouseEnterPopupContent() {
    hoveringPopupContentRef.current = true;
    displayPopup();
  }
  function onMouseLeavePopupContent() {
    hoveringPopupContentRef.current = false;
    hidePopup();
  }
  function onMouseLeavePopupTrigger() {
    timeoutId.current = setTimeout(function () {
      if (!hoveringPopupContentRef.current) {
        hidePopup();
      }
    }, DEFAULT_CLOSE_POPUP_TIMEOUT);
  }
  var title = parentLink.title,
    url = parentLink.url,
    slug = parentLink.slug,
    pageType = parentLink.pageType,
    as = parentLink.as,
    className = parentLink.className;
  return /*#__PURE__*/React.createElement(Popup, {
    className: DEFAULT_CLASS_NAME,
    open: showPopup,
    flowing: true,
    trigger: /*#__PURE__*/React.createElement("div", {
      className: "trigger-container",
      ref: triggerRef,
      onMouseEnter: displayPopup,
      onMouseLeave: onMouseLeavePopupTrigger
    }, /*#__PURE__*/React.createElement(BaseLink, {
      title: title,
      url: url,
      slug: slug,
      type: pageType.toLowerCase(),
      as: as,
      className: className
    }), /*#__PURE__*/React.createElement(Button, {
      icon: true,
      className: "trigger",
      onClick: toggleShowPopup,
      "aria-label": "Toggle menu"
    }, /*#__PURE__*/React.createElement(Icon, {
      iconName: "angle-down"
    }))),
    content: /*#__PURE__*/React.createElement(PopupContent, {
      onMouseEnter: onMouseEnterPopupContent,
      onMouseLeave: onMouseLeavePopupContent,
      links: links,
      maxLinksToShow: maxLinksToShow,
      onLinkClick: hidePopup
    }),
    position: PopupUtils.getSafePosition(triggerRef, {
      position: 'bottom center'
    }),
    onMount: onPopupMount,
    onUnmount: onPopupUnmount
  });
}
AccordionsPopup.defaultProps = defaultProps;